var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c("Item-List", {
            ref: "list",
            attrs: {
              "add-button": "Agregar un equipo",
              minItems: 1,
              maxItems: 15,
              icon: "mdi-plus",
              "initial-ammount": 1
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c("Hardware", {
                      attrs: {
                        formValues: _vm.formValues,
                        isFormComplete: props.isFormComplete,
                        oldItem: props.oldItem
                      },
                      on: { receiveData: _vm.receiveData }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("Form-Navigation-Buttons", {
        on: {
          previousStep: _vm.previousStep,
          validateStep: _vm.validateStep,
          reset: function($event) {
            return _vm.$router.push({ name: "tickets" })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }